import cx from "classnames";
import React from "react";
import blockSizes from "../../../App/blockSizes.scss";
import styles from "./JSONViewer.scss";

export const JSONViewer = ({ block }) => (
  <div className={cx(blockSizes.normalBlock, styles.JSONViewer)}>
    <pre>{JSON.stringify(block.getData().toJS(), null, "  ")}</pre>
  </div>
);
